<template>
	<section class="sub_container">
		<div class="search_form">
			<h2>주문통합 뷰</h2>
			<div class="contents">
				<div class="row">
					<div class="cell">
						<label>주문최종 상태</label>
						<div class="custom-select opt-color">
              <select class="select" v-model="srchParam.orderStatusCode">
                <option :value="''">전체</option>
                  <template v-for="(orderStatusCode, index) in orderStatusCodeList">
                    <option :value="orderStatusCode.codeValue" :key="index">{{orderStatusCode.codeName}}</option>
                  </template>
              </select>
						</div>
					</div>
          <div class="cell">
            <label>주문 그룹번호</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="주문 그룹번호"
                  v-model="srchParam.searchOrderGroupNo"
                  @keyup.enter="searchBtn" >
            </div>
          </div>
				</div>
        <div class="row">
          <div class="cell">
            <label for="">SO 번호</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="SO 번호"
                  v-model="srchParam.searchSoNo"
                  @keyup.enter="searchBtn" >
            </div>
          </div>
          <div class="cell">
            <label>주문 물류센터</label>
            <div class="custom-select opt-color">
              <select class="select" v-model="srchParam.searchLogistic">
                <option value=''>전체</option>
                <option value='D507'>안성</option>
                <option value='D510'>서울</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <label for="">주문처</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="주문처"
                  v-model="srchParam.searchOrderPartnerName"
                  @keyup.enter="searchBtn" >
            </div>
          </div>
          <div class="cell">
            <label for="">배송처</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="배송처"
                  v-model="srchParam.searchCustomerName"
                  @keyup.enter="searchBtn" >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <label>주문일자</label>
						<inputDate id="stDate" v-model="srchParam.stDate" />
          </div>
          <div class="cell loc_edDate">
            <label for="" style="height:19px;"></label>
						<inputDate id="edDate" v-model="srchParam.edDate" />
          </div>
        </div>
			</div>
		</div>
		<!-- end search-form -->
    <div class="sub_sh_btn_wrap">
      <button class="sh_btn" @click="searchBtn">조회</button>
    </div>
    <div class="sub_contents">
      <div class="sub_contents_wrap">
        <h1>견적요청 컨텐츠</h1>
        <div class="board_list_top mb5">
          <div class="sub_left_wrap">
            <div class="destxt02" style="top: 0px;">조회 <span>{{listTotCnt}} </span>건</div>
          </div>
          <div class="sub_right_wrap">
            <div class="btn_area pb0">

            </div>
          </div>
        </div>
        <div class="board_list type03 tbl_box" style="height: 358px;">
          <table  class="board_table" style="table-layout:fixed; width:1250px;">
            <caption class="hide">상품주문 조회 테이블</caption>
            <colgroup>
              <col style="width:50px;">	<!--No -->
              <col style="width:100px;">	<!-- 주문그룹 번호 -->
              <col style="width:115px;">	<!-- 주문 번호 -->
              <col style="width:100px;">	<!-- 주문 일시 -->
              <col style="width:100px;"> <!-- SO 번호 -->
              <col style="width:40px;">	<!-- 구분 -->
              <col style="width:70px;">	<!-- 종류 (관련이동) -->
              <col style="width:70px;">	<!-- 주문 최종상태 -->
              <col style="width:100px;">	<!-- 대리점 -->
              <col style="width:100px;">	<!-- 배송처 -->
              <col style="width:60px;">	<!-- 주문 물류 -->
              <col style="width:65px;">	<!-- 요청금액 (VAT제외) -->
              <col style="width:50px;">	<!-- 주문 품목 -->
              <col style="width:50px;">	<!-- 주문 수량 -->
              <col style="width:50px;">	<!-- 취소 품목 -->
              <col style="width:50px;">	<!-- 반품승인 수량 -->
              <col style="width:80px;">	<!-- 주문담당자 -->
            </colgroup>
            <thead>
              <tr>
                <th scope="col">No</th>
                <th scope="col">주문그룹 번호</th>
                <th scope="col">주문번호</th>
                <th scope="col">주문 일시</th>
                <th scope="col">SO 번호</th>
                <th scope="col">구분</th>
                <th scope="col">종류</th>
                <th scope="col">주문<br />최종상태</th>
                <th scope="col">대리점</th>
                <th scope="col">배송처</th>
                <th scope="col">주문<br/>물류</th>
                <th scope="col">요청금액<br />(VAT제외)</th>
                <th scope="col">주문<br />품목</th>
                <th scope="col">주문<br />수량</th>
                <th scope="col">취소<br />품목</th>
                <th scope="col">반품승인<br />수량</th>
                <th scope="col">주문<br />담당자</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in dataList" v-bind:key="index"  @click="clickOrderInfo(data.orderNo)">
                <td>{{index + 1}}</td>	<!--No -->
                <td>{{data.orderGroupId}}</td>	<!-- 주문그룹 번호 -->
                <td class="tal">{{data.orderId}}</td>	<!-- 주문 번호 -->
                <td>{{data.createTimestamp}}</td>	<!-- 주문 일시 -->
                <td>{{data.erpSoId}}</td>	<!-- SO 번호 -->
                <td>{{data.orderClassName}}</td>	<!-- 구분 -->
                <td>
                  <div class="estbtn">
                    <span :class="renderStatusClass(data.orderStatusCode, data.orderClassCode, data.orderTypeCode)">
                      {{data.orderTypeName}}
                    </span>
                  </div>
                </td>	<!-- 종류 (관련이동) -->
                <td>{{data.orderStatusName}}</td>	<!-- 주문 최종상태 -->
                <td class="tal">{{data.orderPartnerName}}</td>	<!-- 대리점 -->
                <td class="tal">{{data.customerName}}</td>	<!-- 배송처 -->
                <td>{{data.logisticsPartnerName}}</td>	<!-- 주문 물류 -->
                <td class="tar">{{Utils.numberComma(data.orderPrice)}}</td>	<!-- 요청금액 (VAT제외) -->
                <td class="tar">{{Utils.numberComma(data.itemCnt)}}</td>	<!-- 주문 품목 -->
                <td class="tar">{{Utils.numberComma(data.itemOrderCnt)}}</td>	<!-- 주문 수량 -->
                <td class="tar">{{Utils.numberComma(data.itemCancelCnt)}}</td>	<!-- 취소 품목 -->
                <td class="tar">{{Utils.numberComma(data.itemReturnCnt)}}</td>	<!-- 반품승인 수량 -->
                <td class="tal">{{data.createUserName}}</td>	<!-- 주문담당자 -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
		<!-- end sub_contents -->
	</section>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import InputDate from '@/components/InputDate'
import SelectCodeList from '@/components/SelectCodeList'
import OrderStatusDetailPop from './OrderStatusDetail'

export default {
  name: 'orderStatus',
	components: { InputDate, SelectCodeList, OrderStatusDetailPop },
	data () {
		return {
      AppConfig,
      Utils,
      orderStatusCodeList: [],
      listTotCnt: '0',
      orderListHtml: '',
      dataList: [],
      srchParam: {
        stDate: '',
        edDate: '',
        orderStatusCode: '',
        orderStatusCode: "",
        searchOrderNo: "",
        searchOrderGroupNo: "",
        searchLogistic: "",
        searchOrderPartnerName: "",
        searchChargeName: "",
        searchCustomerName: "",
        searchSoNo: "",
        searchSection: [],
      }
		}
  },
  methods: {
    setRightCalendarStyle() {// 우측 카렌다 스타일 지정
      var month_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[2];
      var year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[4];
      var decade_year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[6];
      
			$(month_calendar).css('left', '-123px');
			$(year_calendar).css('left', '-123px');
			$(decade_year_calendar).css('left', '-123px');
    },
    setSrchParamInit() {// 검색 조건값 초기화
      let today = new Date();
      let yyyy = today.getFullYear();
      let srchParam = this.srchParam;

      srchParam.stDate = Utils.getToday();
      srchParam.edDate = Utils.getToday();
      srchParam.orderStatusCode = '';
      srchParam.searchOrderNo = '';
      srchParam.searchOrderGroupNo  = '';
      srchParam.searchLogistic  = '';
      srchParam.searchOrderPartnerName  = '';
      srchParam.searchChargeName  = '';
      srchParam.searchCustomerName  = '';
      srchParam.searchSoNo  = '';
      srchParam.searchSection  = ['12','22','31','32','42','93'];
    },
    searchBtn() { // 조회버튼 클릭시
      const searchUrl = '/order/orderStatusList';
      let srchParam = this.srchParam;

      var dateDiff = Utils.getDiffDate(srchParam.edDate, srchParam.stDate);
      dateDiff =  dateDiff / 1000 / 60 / 60 / 24;
      
      if (dateDiff > 7) {
        Vue.Alert.alert("검색 기간은 7일을 넘을 수 없습니다.");
        srchParam.stDate = Utils.getToday();
        srchParam.edDate = Utils.getToday();
        return false;
      }
      if (dateDiff < 0) {
        Vue.Alert.alert("검색 기간 종료일을 시작일보다 이전 날짜를 입력하였습니다.");
        srchParam.stDate = Utils.getToday();
        srchParam.edDate = Utils.getToday();
        return false;
      }
      
      this.listTotCnt = 0;
      this.dataList = [];

      if (srchParam.searchOrderPartnerName && srchParam.searchOrderPartnerName != '') {
        srchParam.searchOrderPartnerName = srchParam.searchOrderPartnerName.toUpperCase();
      }
      
      Utils.showLoading('loading_grid_orderList');
      
      Vue.httpClient
        .post(searchUrl, srchParam)
        .then(result => {
          if (result.data.result != undefined) {
            this.dataList = result.data.result.list;
            this.listTotCnt = result.data.result.total
          }
        })
        .catch(error => { console.log(error); })
				.finally(_ => {
					Utils.hideLoading('loading_grid_orderList');
				});
    },
    setOrderStatusList() { // 주문최종상태 조건 지정
      Vue.httpClient
        .get('/common/code/list', {params: {codeType: 'ORDER_STATUS_CODE'}})
        .then((response) => {
          var tempList = [];
          if (response.data.result) {
            for (var i in response.data.result) {
              var codeValueOri = response.data.result[i].codeValue;
              if (codeValueOri != '10' && codeValueOri != '11'
                  && codeValueOri != '12' && codeValueOri != '13'
                  && codeValueOri != '14' && codeValueOri != '30'
                  && codeValueOri != '31' && codeValueOri != '32'
                  && codeValueOri != '33' ) { // 로컬 견적 주문요청 단계 전까지 검색 X
                if (codeValueOri != '40' && codeValueOri != '41'
                    && codeValueOri != '42' && codeValueOri != '43'
                    && codeValueOri != '97' && codeValueOri != '98'
                    && codeValueOri != '97' && codeValueOri != '98') {
                  tempList.push(response.data.result[i]);
                } else {
                  response.data.result[i].codeName = response.data.result[i].codeName + '(로컬)'
                  tempList.push(response.data.result[i]);
                }
              }
            }
            this.orderStatusCodeList = tempList;
          }
        });
    },
    renderStatusClass(orderStatusCode, orderClassCode, orderTypeCode) {
      let result = 'outline-green'; // 일반
      if (orderClassCode == "12") { // 보험
        result = 'outline-red';
      }
      if (orderClassCode == '21' || orderClassCode == '22') { // 로컬
        result = 'outline-blue';
      }

      return result;
    },
    clickOrderInfo(orderNo) {
      this.$router.push({
        name: 'OrderStatusDetail' ,
        params : {orderNo}
      });
    }
  },
	mounted() {
    this.$nextTick(function() {
			var $this = this;
      this.setRightCalendarStyle(); // 우측 카렌다 스타일 지정
      this.setSrchParamInit(); // 검색 조건값 초기화
      this.setOrderStatusList(); // 주문최종상태 조건 지정
      this.searchBtn(); // 조회
		});
	},
	computed: {
		// 사용자명
		userName() {
			return window.$store.getters['Login/getUserName']
		}
	}

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/OrderStatus.vue